module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/testimonial/testimonial-style4/testimonial-style4.component.scss
// module id = ./src/app/features/testimonial/testimonial-style4/testimonial-style4.component.scss
// module chunks = main